import { RouteObject } from 'react-router';
import { lazy } from 'react';

// project imports
import { AppModule, Routes } from 'utils/constants';
import Loadable from 'components/loading/Loadable';
import MainLayout from 'components/layout/MainLayout/MainLayout';

// routing
const ActivityEvents = Loadable(
  lazy(() => import('views/modules/System/ActivityEvents/ActivityEvents'))
);
const Alarms = Loadable(
  lazy(() => import('views/modules/System/Alarms/Alarms'))
);

// ==============================|| REPORTING ROUTES ||============================== //

export const routesSystem: RouteObject = {
  path: `${Routes.BASE_PATH}:tenant`,
  element: <MainLayout module={AppModule.SYSTEM} />,
  children: [
    {
      path: Routes.SYSTEM.ACTIVITY_EVENTS,
      element: <ActivityEvents />
    },
    {
      path: Routes.SYSTEM.ALARMS,
      element: <Alarms />
    }
  ]
};
